import React from "react";

import PaymentRedirect from "./PaymentRedirect";
import PaymentResult from "./PaymentResult";
import { Strings,ChangeLanguage} from "INTL/i18n";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import changeLanguage from "MODULES/App/actions/ChangeLanguage";
// Strings
import "./Payer.less";
import { PayerParam } from "./PayerConstants";
import "./Payer.css";
import PaymentBase from "./PaymentBase";
import {PageView, initGA} from "MODULES/Tracking";
import { GOOGLE_ANALYTICS } from "CONSTANTS/AppConstants";

class PaymentSuccess extends PaymentBase {
  constructor(props) {
    super(props);
    this.state = {
      redirectUrl: "",
    };
  }

  componentDidMount() {
    initGA(GOOGLE_ANALYTICS.TRACKING_ID);
    PageView();
    let searchQueryString = window.location.hash.split("?")[1];
    let redirectQueryString = "?" + window.location.hash.split("?")[2];
    let urlParams = new URLSearchParams(searchQueryString);
    let languageCode = urlParams.get(PayerParam.lang);
    ChangeLanguage(languageCode);
    this.props.changeLanguageInState(languageCode);
    let redirectUrl;
    if (urlParams.get(PayerParam.redirect)) {
      redirectUrl = urlParams.get(PayerParam.redirect) + redirectQueryString;
    }
    this.setState({
      redirectUrl: redirectUrl,
    });
  }

  render() {
    return (
      <div>
        {this.renderHeader(this.props.selectedLanguage)}
        <div className="App_body">
          <div className="payerContainer">
            <div className={this.props.selectedLanguage === "ar"?"Rectangle_dialog_rtl":"Rectangle_dialog"}>
              <div className={this.props.selectedLanguage === "ar"?"Thank_You_Label_RTL":"Thank_You_Label"}>{Strings("thank_you")}</div>
              <div className={this.props.selectedLanguage === "ar"?"Thank_You_Desc_RTL":"Thank_You_Desc"}>{Strings("thank_you_desc")}</div>
              {this.state.redirectUrl && (
                <PaymentRedirect redirectUrl={this.state.redirectUrl} />
              )}
              <PaymentResult />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedLanguage: state.LanguageReducer.selectedLanguage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeLanguageInState: changeLanguage,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentSuccess);



// WEBPACK FOOTER //
// ./src/modules/Payer/PaymentSuccess.js